module.exports = __webpack_public_path__ + "img/equipos-de-sala-gal-1-zoom.19c3c86e.png";